import { Game, eModelAsset } from "../../../Game";
import { eBatchGroup, Gameplay, TIMER } from "../../Gameplay";
import { GameWorld } from "../GameWorld";
import { BgRingManager } from "./BgRingManager";
import { ModelUtils } from "../../../Utils/ModelUtils";



export class BgRing {
    private static _MATERIALS1: pc.StandardMaterial[];
    private static _MATERIALS2: pc.StandardMaterial[];

    private static _CLONE_PARENT: pc.Entity;

    private _entity: pc.Entity;
    private _pos: pc.Vec3;
    private _id: number;
    private _state: number;

    private static readonly _MIN_STEP_Z = 0;
    private static readonly _MAX_STEP_Z = 0.5;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!BgRing._CLONE_PARENT) {
            this._entity = BgRing._CLONE_PARENT = new pc.Entity("bgRing");
            this._entity.addComponent(pc.eCompomentType.model, {
                type: pc.eModelType.asset,
                asset: Game.app.assets.find(eModelAsset.bgRing, pc.ASSET_MODEL),
                castShadows: false,
                castShadowsLightmap: false,
                lightmapped: false,
                batchGroupId: Gameplay.BATCH_GROUP_ID[eBatchGroup.solid_1],
            });

            // Zmenit matieral, aby sla meni alfa
            /*BgRing._MATERIALS1 = [];
            BgRing._MATERIALS2 = [];

            ModelUtils.cloneModelMaterials(this._entity.model, {
                blendType: pc.BLEND_NORMAL,
                opacity: 0.1
            }, BgRing._MATERIALS1, BgRing._MATERIALS2, Game.APP.assets, "opacity_");*/

            //this._entity.model.meshInstances.forEach((mesh: pc.MeshInstance, i: number) => { mesh.material = BgRing._MATERIALS2[i]; });
        }
        else {
            this._entity = BgRing._CLONE_PARENT.clone();
        }

        this._entity.enabled = false;
        Game.app.root.addChild(this._entity);

        this._pos = new pc.Vec3(GameWorld.CENTER_X, GameWorld.GROUND_Y, 0);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): BgRing {
        this._entity.enabled = false;
        this._state = -1;
        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(id: number, z: number): void {
        this._id = id;
        this._state = 0;

        // Pozice
        this._pos.z = z;
        this._entity.setPosition(this._pos);

        // Alfa
        this._entity.setLocalScale(0, 0, 0);
        //ModelUtils.setOpacity(this._entity.model, 0);

        this._entity.enabled = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(viewZ: number, viewStep: number): boolean {
        // Vypocitat zbyvajici vzdalenost, po kterou bude prstenec existovat
        let remDis = (viewZ + BgRingManager.RING_DEACT_VIEW_OFFSET) - this._pos.z;

        if (remDis <= 0) {
            this.reset();
            return false;
        }

        // Aktualni pozice v zivote prstence
        let lifePos = 1 - (remDis / -BgRingManager.RING_ACT_VIEW_OFFSET);

        // Rotace prstence
        let rotSpeed = 12 * TIMER.deltaS;

        this._entity.rotate(0, 0, (this._id & 1) == 0 ? rotSpeed : -rotSpeed);

        if (viewStep != 0) {
            // Alfa
            if (this._state == 0) {
                let i = lifePos / 0.25;

                if (i >= 1) {
                    // Zobrazeni dokonceno
                    i = 1;
                    this._state++;
                }

                i = pc.BackOut(i);
                this._entity.setLocalScale(i, i, i);
                //ModelUtils.setOpacity(this._entity.model, i);
            }

            // Pohyb na Z (cim mensi vzdalenost prstenci zbyva, tim rychleji se pohybuje)
            this._pos.z += BgRing._MIN_STEP_Z + pc.CubicIn(lifePos) * (BgRing._MAX_STEP_Z - BgRing._MIN_STEP_Z);
            this._entity.setPosition(this._pos);
        }

        return true;
    }
}